import get from 'lodash/get';
import {
  CLEAN_STATE,
  LOAD_SIMILARITY_SEARCH_RESULTS,
  LOAD_SIMILARITY_SEARCH_RESULTS_FAILURE,
  LOAD_SIMILARITY_SEARCH_RESULTS_SUCCESS,
  REDUCER_KEY_SIMILARITY_SEARCH,
  SIMILARITY_SEARCH,
  SIMILARITY_SEARCH_FAILURE,
  SIMILARITY_SEARCH_SUCCESS,
  SUBMIT_SIMILAR_SUBSTANCE,
  SUBMIT_SIMILAR_SUBSTANCE_FAILURE,
  SUBMIT_SIMILAR_SUBSTANCE_SUCCESS,
} from '@Pages/RetroSynthesis/SimilaritySearch/constants';
import ResultsInterface from '@Services/ResultsInterface';
import { REDUCER_KEY_RS } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import MessageBroker from '@Services/MessageBroker';
import RequestUrls from '@Constants/RequestUrlsConstants';
import { addProjectAction, fetchProjectsAction } from '@Pages/RetroSynthesis/RetroSynthesisProjects/actions';
import { withGlobalSpinnerActionEnhancer } from '@Utils/Redux/withGlobalSpinnerActionEnhancer';
import { updateDialog as updateDialogAction } from '@Containers/Dialogs/DialogsActions';
import { typeOfRsSimilaritySearchDialog } from '@Containers/Dialogs/DialogsMapperConstants';
import { isAnyPredictiveRetrosynthesisAvailable } from '../predictiveUtils';

const LOAD_MORE_COUNT = 9;

export const openSimilaritySearchDialog = (project) =>
  updateDialogAction({
    id: typeOfRsSimilaritySearchDialog,
    typeOfRsSimilaritySearchDialog,
    dialogType: typeOfRsSimilaritySearchDialog,
    project,
  });

export const loadSimilaritySearchResults = () => async (dispatch, getState) => {
  dispatch({ type: LOAD_SIMILARITY_SEARCH_RESULTS });

  const { resultPayload, reactions, totalItems } = getState().get(REDUCER_KEY_RS).get(REDUCER_KEY_SIMILARITY_SEARCH);

  const firstItem = (reactions && reactions.length) || 1;
  const lastItem = firstItem + LOAD_MORE_COUNT < totalItems ? firstItem + LOAD_MORE_COUNT : totalItems;

  const payload = { ...resultPayload, firstItem, lastItem };
  ResultsInterface.getResults(payload).subscribe({
    next: ({ data }) =>
      dispatch({
        type: LOAD_SIMILARITY_SEARCH_RESULTS_SUCCESS,
        searchResult: data,
      }),
    error: (e) =>
      dispatch({
        type: LOAD_SIMILARITY_SEARCH_RESULTS_FAILURE,
        payload: e,
      }),
  });
};

export const cleanState = () => ({ type: CLEAN_STATE });

export const fetchSimilaritySearch = (project) => async (dispatch) => {
  dispatch({ type: SIMILARITY_SEARCH });
  try {
    const { targetStructure, id } = project;
    const result = await MessageBroker.send(RequestUrls.rsFindSimilar, { id });
    const { resultName, context, resultSize, databaseId } = result;
    const resultPayload = {
      databaseId,
      resultName,
      context,
      firstItem: 1,
      lastItem: 10,
      similarityMol: targetStructure.structure,
      forPlanner: true,
      sort: 'SIMILARITY',
      order: 'desc',
    };

    dispatch({
      type: SIMILARITY_SEARCH_SUCCESS,
      resultPayload,
      totalItems: resultSize,
    });
  } catch (e) {
    dispatch({
      type: SIMILARITY_SEARCH_FAILURE,
      payload: e,
    });
  }
};

export const submitSimilarSubstance = withGlobalSpinnerActionEnhancer(
  ({ project, substance, databaseId, location }) =>
    async (dispatch) => {
      dispatch({ type: SUBMIT_SIMILAR_SUBSTANCE });
      try {
        const isRtEnabled = isAnyPredictiveRetrosynthesisAvailable();
        const { id: projectId, publishedParameters: publishedParams, predictedParameters: predictedParams } = project;
        const rxn = get(substance, ['details', 'id']);

        // Change publishedRouteCount to 0 for the current project
        const payload = await MessageBroker.send(RequestUrls.rsEditProject, {
          projectId,
          changeTarget: true,
        });
        // Create new project with the same paramaters
        await dispatch(
          addProjectAction(
            {
              rxn,
              databaseId,
              publishedParams,
              ...(isRtEnabled && { predictedParams }),
            },
            { location }
          )
        );
        // Re-fetch projects to get updates
        dispatch(fetchProjectsAction({}, true));
        dispatch({ type: SUBMIT_SIMILAR_SUBSTANCE_SUCCESS, payload });
      } catch (error) {
        dispatch({ type: SUBMIT_SIMILAR_SUBSTANCE_FAILURE, payload: error });
      }
    }
);
